module.exports = __webpack_public_path__ + "img/飓风.1f49609a.png";